<div
  [matMenuTriggerFor]="contextMenu"
  [style.left]="contextMenuPosition.x"
  [style.top]="contextMenuPosition.y"
  style="visibility: hidden; position: fixed"
></div>
<mat-menu #contextMenu="matMenu">
  <ng-template let-item="item" matMenuContent>
    @for (contextMenuLine of contextMenuLines; track contextMenuLine.text) {
      @if (contextMenuLine.topSeparatorFlag) {
        <div class="m-4 pl-10 horizontal-separator"></div>
      }
      <button (click)="contextMenuLineClickHandler(contextMenuLine)" mat-menu-item>
        <div class="context-menu-line-content">
          <span>{{ contextMenuLine.text }}</span>
          @if (contextMenuLine.suffixIcon) {
            <mat-icon [svgIcon]="contextMenuLine.suffixIcon" class="accent-fg context-menu-suffix-icon"></mat-icon>
          }
        </div>
      </button>
    }
  </ng-template>
</mat-menu>
